import {SuggestionPrimitive, useAuiState} from '@assistant-ui/react';
import {type AutoColor, CalloutIcon, type IconName} from '@wandb/components';
import React from 'react';

type WBAgentSuggestionItem = {
  icon: IconName;
  color: AutoColor;
  title: string;
  label: string;
  prompt: string;
};
export const SUGGESTION_ITEMS: WBAgentSuggestionItem[] = [
  {
    icon: 'report',
    color: 'teal',
    title: 'Summarize this project',
    label: '',
    prompt: 'Summarize this project',
  },
  {
    icon: 'lightbulb-info',
    color: 'blue',
    title: 'Recommend my next experiment',
    label: '',
    prompt: 'Recommend my next experiment',
  },
  {
    icon: 'chart-line',
    color: 'gold',
    title: 'What patterns do you see in my results?',
    label: '',
    prompt: 'What patterns do you see in my results?',
  },
];

export const SuggestionItem = () => {
  const title = useAuiState(s => s.suggestion.title);
  const meta = SUGGESTION_ITEMS.find(i => i.title === title);
  if (!meta) {
    return null;
  }
  return (
    <SuggestionPrimitive.Trigger
      send
      className="flex flex-1 basis-auto min-w-0 pr-16 pl-12 py-6 items-center gap-8 self-stretch rounded-lg border border-moon-250 shadow-flat hover:bg-moon-100 disabled:cursor-not-allowed disabled:opacity-50">
      <CalloutIcon icon={meta.icon} color={meta.color} size="sm" />
      <SuggestionPrimitive.Title className="min-w-0 flex-1 text-left text-moon-800 truncate font-medium text-sm leading-[22.4px]" />
    </SuggestionPrimitive.Trigger>
  );
};
